import { render, staticRenderFns } from "./CourseRegister.vue?vue&type=template&id=35f3d1e7"
import script from "./CourseRegister.vue?vue&type=script&lang=js"
export * from "./CourseRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports